"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToInsertedImage = exports.insertImageFromClickToAdd = void 0;
var scroll_into_view_if_needed_1 = __importDefault(require("scroll-into-view-if-needed"));
var Utils_1 = require("Project/QwilrEditor/Utils");
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var PasteActions_1 = require("../PasteActions");
var Image_1 = require("ContentTokens/Models/Image");
var insertImageFromClickToAdd = function (editor, imageNode) {
    if ((0, Utils_1.isInsideDummyNode)(editor, editor.selection)) {
        (0, PasteActions_1.insertOverLayoutWidget)(editor, [imageNode]);
        return;
    }
    var startPath = slate_1.Range.start(editor.selection).path;
    var closestBlock = (0, Utils_1.getClosestBlock)(editor, startPath);
    if (!closestBlock) {
        throw new Error("Could not find a nearest block when inserting an image from click to add action");
    }
    var _a = __read(closestBlock, 2), closestBlockNode = _a[0], closestBlockPath = _a[1];
    var shouldReplaceBlock = slate_1.Node.string(closestBlockNode) === "";
    var replaceBlockPathRef = slate_1.Editor.pathRef(editor, closestBlockPath);
    slate_1.Transforms.splitNodes(editor);
    slate_1.Transforms.insertNodes(editor, imageNode);
    if (shouldReplaceBlock && replaceBlockPathRef.current) {
        slate_1.Transforms.removeNodes(editor, { at: replaceBlockPathRef.unref() });
    }
};
exports.insertImageFromClickToAdd = insertImageFromClickToAdd;
var scrollToInsertedImage = function (editor, insertedImagePath) {
    var insertedImageNodeEntry = (0, Utils_1.checkAncestors)(editor, insertedImagePath, function (c) { return (0, Image_1.isImageNode)(c); });
    if (!insertedImageNodeEntry) {
        return;
    }
    var _a = __read(insertedImageNodeEntry, 1), insertedImageNode = _a[0];
    var domNode = slate_react_1.ReactEditor.toDOMNode(editor, insertedImageNode);
    if (!domNode) {
        return;
    }
    (0, scroll_into_view_if_needed_1.default)(domNode, {
        scrollMode: "if-needed",
        behavior: "smooth",
        block: "center",
    });
};
exports.scrollToInsertedImage = scrollToInsertedImage;
